import React, { useEffect } from 'react';
import { translateScript } from 'Utils/UtilityFunctions';

export interface PropsForLanguageTranslator {
  id: string,
  padding?: string
}

const defaultProps = {
  padding: '',
};

const SelectLanguage = function SelectLanguage(props: PropsForLanguageTranslator) {
  // const changeGoogleTranslate = () => {
  //   if (
  //     window.$('.goog-te-combo option:first-child').text() === 'Select Language'
  //   ) {
  //     window
  //       .$('.goog-te-combo')
  //       .css({ padding: '10px', border: '1px solid #CFDAE8', color: '#000' });
  //   } else {
  //     setTimeout(changeGoogleTranslate, 50);
  //   }
  // };

  useEffect(() => {
    translateScript();
  }, []);

  const { padding, id } = props;

  return (
    <div
      style={{
        padding,
      }}
      id={id}
    />
  );
};

SelectLanguage.defaultProps = defaultProps;
export default SelectLanguage;
